import { useState } from 'react';

type Args = {
  copiedMessageTimeoutMs: number | false | 'default';
};

export function useCopyToClipboard({
  copiedMessageTimeoutMs: copiedMessageTimeoutMsProp,
}: Args) {
  const copiedMessageTimeoutMs =
    copiedMessageTimeoutMsProp === 'default'
      ? 5_000
      : copiedMessageTimeoutMsProp;

  const [showCopiedMessage, setShowCopiedMessage] = useState(false);

  const copyToClipboard = async (string: string) => {
    if (!window.isSecureContext && !navigator.clipboard)
      throw new Error(
        'Cannot copy to clipboard because application is not within a secure context',
      );

    await navigator.clipboard.writeText(string);

    if (copiedMessageTimeoutMs !== false) {
      setShowCopiedMessage(true);
      setTimeout(() => {
        setShowCopiedMessage(false);
      }, copiedMessageTimeoutMs);
    }
  };

  return { copyToClipboard, showCopiedMessage };
}
